<template>
    <!--電話驗證-->
    <div class="login">
        <navigation-bar Close/>
        <div class="main-content">
            <div class="logo"><Logo/></div>
            <el-form class="textBox" :model="passwordForm" ref="loginForm" >
                <p class="text-center mb-2 blue" v-if="!getVerify">
                    請詢問鄰近店家協助修改或找回密碼
                </p>
            <el-form-item>
                <OpenEyes :value="passwordForm.tel" :disabled="true" class="input-round">
                    <template #front>
                        <div class="CountryCodeTW">
                            {{passwordForm.countryCodeData.enName}}{{passwordForm.countryCodeData.code}}
                        </div>
                    </template>
                </OpenEyes>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="輸入驗證碼" type="tel" pattern="[0-9]*" v-model="passwordForm.verificationCode" maxlength="4" autocomplete="off">
                    <el-button :disabled="isClick" v-if="getVerify" @click="checkIsRegister(passwordForm.tel)" slot="append" class="send-btn">{{resendTitle}}</el-button>
                </el-input>
            </el-form-item>
            </el-form>


            <div class="forget" v-if="getVerify" @click="callOutCode(passwordForm.tel)">
                收不到驗證碼？通話取得
            </div>
            <div class="btn_box">
                <el-button round @click="submit()" type="warning">下一步</el-button>
            </div>
        </div>
        <toast/>
        <div class="brand" v-if="!isWeb">
          <span>LIFE LINK 串門子品牌服務系統</span>
        </div>
    </div>
</template>

<script>
import {checkPhone, checkPhoneByCountryCode} from '@/util/validators';
import Toast from '@/components/Toast.vue';
import {SHOW_TOAST} from "@/store/mutationTypes";
import * as mutationTypes from "@/store/mutationTypes";
import Logo from "@/components/Logo";
import OpenEyes from "@/components/OpenEyes"
import {getCryptoUserPhone} from "@/util/cryptoLocalStorage";
export default {
  name: "PhoneVerify",
    props: {
        isWeb: Boolean,
        dataTokenWeb: {default: ''},
    },
  components:{ Toast,Logo,OpenEyes },
  // props: {
  //     nextTo: { type: String, default: ''},       //接下來要跳的頁面
  // },
  data() {
    return {
      nextTo: this.isWeb? this.dataTokenWeb.nextTo :this.$route.query.nextTo,        //下一頁要跳到哪裡？ 傳入 ForgotPassword 會走忘記密碼的流程， 傳入 ChangePassword 會走重設密碼的流程
      passwordForm: {
        tel: this.isWeb? this.dataTokenWeb.tel : this.$route.query.tel,
        verificationCode: '',
        countryCodeData: {
            cnName: "台灣",
            code: this.isWeb? (this.dataTokenWeb.countryCode || "+886") : (this.$route.query.countryCode || "+886"),
            enName: this.isWeb? (this.dataTokenWeb.countryName || "TW") : (this.$route.query.countryName || "TW")
        },
      },
      error: {
        phone: false,
        verificationCode: false,
        timer: 0,  
      },
      time: 61,
      resendTitle:'發送驗證碼',
      getVerify: true, //控制發送驗證碼案紐
      isClick: false,

    //Line自動登入
      isLine: this.isWeb? this.dataTokenWeb.isLine : this.$route.query.isLine,
      dataToken: this.isWeb? (this.dataTokenWeb.dataToken || {} ):(this.$route.query.dataToken || {}),
      dataObject: {},
    }
  },
  created() {
      this.getVerify = this.passwordForm.countryCodeData.code === "+886";
  },
  beforeDestroy() {
        //清除定时器
        clearInterval(this.timer);
    },
  mounted() {
      try {
          let dataObject = this.$crypto.uriComponentToObject(this.dataToken)
          this.dataObject = dataObject
      } catch (e) {
          this.dataObject = {}
      }
  },
  methods: {
      /** 開始倒數 */
        starCounting: function () {
            this.time = 61;
            this.isClick = true;
            this.timer = setInterval(this.countdown, 1000);
        },
        /** 倒數 */
        countdown: function () {
            this.time--;
            this.resendTitle = this.time
            //eslint-disable-next-line no-console
            if (this.time === 0) {
                clearInterval(this.timer)
                this.resendTitle = '重新發送'
                this.isClick = false
            }
        },

      /** 驗證是否已註冊 */
      checkIsRegister(tel) {
          clearTimeout(this.error.timer)
          if(!checkPhone(tel)) {
              this.$store.commit(SHOW_TOAST, "手機號碼必須是10位數");
          // } else if (!this.isMyPhone(this.passwordForm.tel)) {
          //     this.$store.commit(SHOW_TOAST, "手機號碼與帳號不符");
          } else {
              let countryData = this.passwordForm.countryCodeData
              //先檢查是否已註冊
              this.$http.fetch`IsRegister${{
                  countryCode: countryData.code,
                  countryName: countryData.enName,
                  phone:tel
              }} ${json => {
                  if(json.data !== null && json.data !== '') {
                      if (json.data.isRegister === 2) {
                          //成功以後要求 api 取得驗證碼
                          this.sendSmsVerifyApi(tel, countryData.code, countryData.enName);

                      } else {
                          this.$store.commit(SHOW_TOAST, "您還未註冊爲會員");
                      }
                  } else {
                      this.$store.commit(SHOW_TOAST, "發送失敗");
                  }
              }}`;

          }
      },

      /** 檢查要發送簡訊的號碼是否與帳號手機號碼一致 */
      isMyPhone(tel) {
          // let myPhone = localStorage.getItem('phone');
          let myPhone = getCryptoUserPhone();
          return (tel === myPhone);
      },

      /** 發送驗證碼 */
      sendSmsVerifyApi(tel, countryCode, countryName) {
          //發送驗證碼
          this.$http.fetch`SendSmsVerify${{
              countryCode: countryCode,
              countryName: countryName,
              type:"forgetPassword",        //忘記密碼固定填 forgetPassword
              phone:tel
          }}
          ${json => {
              if(json.status) {
                  this.starCounting();
                  this.$store.commit(SHOW_TOAST, '驗證碼已發送');
              }else{
                  this.$store.commit(SHOW_TOAST, json.message);
              }
          }}`;
      },

      /** 驗證碼送出核對是否正確 */
      submit: function() {
          clearTimeout(this.error.timer)
          if(!checkPhoneByCountryCode(this.passwordForm.tel, this.passwordForm.countryCodeData.code)) {
              // this.error.phone = true;
              this.$store.commit(SHOW_TOAST, '手機號碼必須是10位數');
              // return this.error.timer = setTimeout(() => {
              //     this.error.phone = false;
              // },4000)
          } else {
              this.checkVerifyCodeApi(this.passwordForm.tel, this.passwordForm.verificationCode);
          }
      },

      /** 檢查驗證碼 */
      checkVerifyCodeApi(tel, verificationCode) {
          let countryData = this.passwordForm.countryCodeData
          this.$http.fetch`CheckVerifyCode${{
              countryCode:countryData.code,
              countryName:countryData.enName,
              type:"forgetPassword",        //忘記密碼固定填 forgetPassword
              phone:tel,
              verifyCode:verificationCode
          }} ${json => {
              if(json.status){
                  //成功以後跳到下一頁
                  //params 內容必須全爲字串
                  if (this.nextTo === 'ForgotPassword') {
                      if(!this.isWeb){
                          //APP、LINE綁定、商圈網頁版用
                          this.$router.push({
                              name: `ResetPwd`,
                              query: {phone: this.passwordForm.tel, verifyCode: this.passwordForm.verificationCode, countryCodeData: countryData, isLine: this.isLine},
                              params: {dataToken: this.dataToken}
                          });
                      }else {
                          //單店純網頁版用
                          const dataToken = {phone: this.passwordForm.tel, verifyCode: this.passwordForm.verificationCode, countryCodeData: countryData, isLine: this.isLine , dataToken: this.dataToken}
                          this.$emit('push', dataToken , 'ResetPwd');
                      }

                  } else if (this.nextTo === 'ChangePassword') {
                      this.$router.push({
                          name: `ChangePassword`,
                          query: {phone: this.passwordForm.tel, verifyCode: this.passwordForm.verificationCode, countryCodeData: countryData, isLine: this.isLine},
                          params: {dataToken: this.dataToken}
                      });
                  }
              } else {
                  this.$store.commit(SHOW_TOAST, "驗證失敗:"+json.message);
              }
          }}`;
      },
      /** 語音驗證 */
      callOutCode: function (tel) {
          let self = this;
          let countryData = this.passwordForm.countryCodeData
          if(!checkPhone(tel)) {
              this.$store.commit(SHOW_TOAST, "手機號碼必須是10位數");
          } else {
              self.$http.fetch`SendPhoneVerify${{
                  countryCode: countryData.code,
                  countryName: countryData.enName,
                  type: 'forgetPassword',
                  phone: tel,
              }} ${json =>{
                  this.$store.commit(mutationTypes.SHOW_TOAST, json.message);
              }}`;
          }
      },

  }
}
</script>
<style lang="less" scoped src="../../less/login.less"/>

